module.exports = __webpack_public_path__ + "static/media/halo-fix.1a7b55ec.svg";